"use client";

import type { LoginKind } from "@/features/auth/api/login";
import { useOtpLogin } from "@/features/auth/hooks/useOtpLogin";
import { useState, Suspense } from "react";
import LoginAside from "./components/LoginAside";
import LoginForm from "./components/LoginForm";
import LoginPanel from "./components/LoginPanel";
import CampaignSelectionForm from "./components/CampaignSelectionForm";
import { SmartfloSessionConflictModal } from "@/features/smartflo/components/SmartfloSessionConflictModal";

export default function Page() {
  const [activeTab, setActiveTab] = useState<LoginKind>("user");
  const login = useOtpLogin(activeTab);

  const isCampaignSelection = login.step === "campaign_selection";

  return (
    <main className="min-h-screen bg-[var(--page)] px-4 py-6 text-[var(--text)] sm:px-6 lg:px-8">
      <SmartfloSessionConflictModal
        open={login.showConflictModal}
        onConfirm={login.handleConfirmTakeover}
        onCancel={login.handleCancelTakeover}
        isLoading={login.isForceLoggingIn}
      />

      <div className="mx-auto grid min-h-[calc(100vh-48px)] max-w-6xl overflow-hidden rounded-[var(--radius-lg)] border border-[var(--border)] bg-[var(--surface)] shadow-[var(--shadow-md)] lg:grid-cols-[0.95fr_1.05fr]">
        <LoginAside />

        <Suspense fallback={<div className="p-10 flex items-center justify-center">Loading...</div>}>
          <LoginPanel activeTab={activeTab} onTabChange={setActiveTab} hideHeaders={isCampaignSelection}>
            {isCampaignSelection ? (
              <CampaignSelectionForm
                userName={login.pendingUser?.profile?.displayName || login.pendingUser?.name || "Agent"}
                campaigns={login.campaigns}
                selectedCampaignId={login.selectedCampaignId}
                onSelectCampaign={login.setSelectedCampaignId}
                onProceed={login.handleProceedToDashboard}
                onBack={login.handleBack}
              />
            ) : (
              <LoginForm
                step={login.step}
                kind={activeTab}
                email={login.email}
                password={login.password}
                otp={login.otp}
                showPassword={login.showPassword}
                isSendingOtp={login.isSendingOtp}
                isVerifyingOtp={login.isVerifyingOtp}
                onEmailChange={login.setEmail}
                onPasswordChange={login.setPassword}
                onOtpChange={login.setOtp}
                onTogglePassword={() => login.setShowPassword(!login.showPassword)}
                onCredentialsSubmit={login.handleCredentialsSubmit}
                onOtpSubmit={login.handleOtpSubmit}
                onBack={login.handleBack}
              />
            )}
          </LoginPanel>
        </Suspense>
      </div>
    </main>
  );
}
